
import { useState } from 'react';
import RollingGallery from '../../../components/feature/RollingGallery';

export default function ServicesSection() {
  const [activeService, setActiveService] = useState<number | null>(null);

  const services = [
    {
      icon: 'ri-hammer-line',
      title: 'Trockenbau',
      description: 'Professionelle Trockenbauarbeiten für Wände, Decken und Raumteilung',
      features: ['Wandaufbau', 'Deckenbau'],
      images: [
        'https://static.readdy.ai/image/8fd098698619b27c03cb78789aa098a8/ec8150fd27e86e64ac5323abb2b8043b.jfif',
        'https://static.readdy.ai/image/8fd098698619b27c03cb78789aa098a8/26cc0ac8cd2803ba8f6b0476b3cb06aa.jfif'
      ]
    },
    {
      icon: 'ri-leaf-line',
      title: 'Gartenarbeiten',
      description: 'Komplette Gartenpflege und Landschaftsgestaltung',
      features: ['Rasenpflege', 'Heckenschnitt', 'Baumfällung', 'Wegebau'],
      images: [
        'https://i.imgur.com/dVjWQzI.jpeg',
        'https://i.imgur.com/gAVkdqk.jpeg',
        'https://i.imgur.com/J2KgThd.jpeg',
        'https://i.imgur.com/nJPeapM.jpeg'
      ]
    },
    {
      icon: 'ri-grid-line',
      title: 'Fliesenarbeiten & Terrassenbau',
      description: 'Fachgerechte Verlegung von Fliesen in Bad, Küche und Wohnbereich',
      features: ['Badezimmer', 'Küche', 'Terrasse', 'Reparaturen'],
      images: [
        'https://img.webme.com/pic/j/jo-allround/20190408_090840.jpg',
        'https://img.webme.com/pic/j/jo-allround/20190508_190222.jpg',
        'https://img.webme.com/pic/j/jo-allround/20190527_201549.jpg',
        'https://img.webme.com/pic/j/jo-allround/HolzTerrasse WR groß.jpg',
        'https://img.webme.com/pic/j/jo-allround/20220801_135540.jpg',
        'https://img.webme.com/pic/j/jo-allround/20200114_093058.jpg',
        'https://static.readdy.ai/image/8fd098698619b27c03cb78789aa098a8/e1aa4e63623d522fe0812ad0bdf32e45.jfif'
      ]
    },
    {
      icon: 'ri-paint-brush-line',
      title: 'Wandgestaltung',
      description: 'Kreative Wandgestaltung und professionelle Malerarbeiten',
      features: ['Tapezieren', 'Streichen', 'Spachteln', 'Dekoputz'],
      images: [
        'https://static.readdy.ai/image/8fd098698619b27c03cb78789aa098a8/d69bffdf456c813f7ce07ed99a73432b.png',
        'https://static.readdy.ai/image/8fd098698619b27c03cb78789aa098a8/3de876d4139b217db02010a993ab1e2c.jfif'
      ]
    },
    {
      icon: 'ri-door-line',
      title: 'Fenster & Türen',
      description: 'Montage und Reparatur von Fenstern und Türen',
      features: ['Montage', 'Reparatur', 'Wartung'],
      images: [
        'https://static.readdy.ai/image/8fd098698619b27c03cb78789aa098a8/ded74e76e17efc0c0f69ee22f92aab7b.jfif',
        'https://static.readdy.ai/image/8fd098698619b27c03cb78789aa098a8/a0eecb6302ec63d9e5bf73fc857a616d.jfif'
      ]
    },
    {
      icon: 'ri-tools-line',
      title: 'Kleinreparaturen',
      description: 'Schnelle Hilfe bei allen kleinen Reparaturen im Haushalt',
      features: ['Sanitär', 'Elektrik', 'Möbel', 'Geräte'],
      images: [
        'https://static.readdy.ai/image/8fd098698619b27c03cb78789aa098a8/02206a23210a245e64ae979f6ccc8568.jfif',
        'https://public.readdy.ai/ai/img_res/34a91243c81836924debc4a86c6274a2.jpg',
        'https://readdy.ai/api/search-image?query=Furniture%20repair%20tools%20and%20woodworking%20materials%2C%20professional%20carpentry%20tools%20for%20furniture%20restoration%20and%20repair%20work%20in%20workshop%20setting&width=320&height=192&seq=repair3&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Appliance%20repair%20tools%20and%20equipment%2C%20professional%20maintenance%20tools%20for%20household%20equipment%20repair%20and%20service%20work%20in%20organized%20workshop&width=320&height=192&seq=repair4&orientation=landscape'
      ]
    }
  ];

  const categories = {
    'Malerarbeiten': [
      'https://readdy.ai/api/search-image?query=Professional%20interior%20wall%20painting%20work%20with%20smooth%20painted%20surfaces%20in%20modern%20home%2C%20clean%20white%20walls%20with%20perfect%20finish%2C%20painting%20tools%20and%20equipment%20visible%2C%20bright%20natural%20lighting%20highlighting%20quality%20craftsmanship&width=800&height=600&seq=painting1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Exterior%20house%20painting%20with%20ladder%20and%20professional%20painting%20equipment%2C%20fresh%20coat%20of%20paint%20on%20building%20facade%2C%20quality%20exterior%20paint%20work%20with%20attention%20to%20detail&width=800&height=600&seq=painting2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Room%20renovation%20with%20freshly%20painted%20walls%20in%20neutral%20colors%2C%20modern%20interior%20design%20with%20clean%20painted%20surfaces%2C%20professional%20painting%20results%20in%20residential%20space&width=800&height=600&seq=painting3&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Professional%20painter%20working%20on%20interior%20walls%20with%20brush%20and%20roller%2C%20quality%20painting%20tools%20and%20materials%2C%20skilled%20craftsmanship%20in%20home%20renovation%20project&width=800&height=600&seq=painting4&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Ceiling%20painting%20work%20with%20professional%20equipment%2C%20smooth%20painted%20ceiling%20surface%20with%20even%20coverage%2C%20interior%20renovation%20showing%20quality%20painting%20techniques&width=800&height=600&seq=painting5&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Color%20consultation%20and%20paint%20samples%20on%20wall%2C%20professional%20color%20matching%20and%20paint%20selection%20process%2C%20interior%20design%20planning%20with%20various%20paint%20colors&width=800&height=600&seq=painting6&orientation=landscape'
    ],
    'Trockenbau': [
      'https://static.readdy.ai/image/8fd098698619b27c03cb78789aa098a8/ec8150fd27e86e64ac5323abb2b8043b.jfif'
    ],
    'Gartenarbeit': [
      'https://static.readdy.ai/image/8fd098698619b27c03cb78789aa098a8/5623afcbd6c1ec0d0a27f601433ca540.jfif'
    ],
    'Renovierung': [
      'https://readdy.ai/api/search-image?query=modern%20bathroom%20renovation%20with%20white%20tiles%2C%20clean%20minimalist%20design%2C%20bright%20lighting%2C%20contemporary%20fixtures%2C%20simple%20background&width=800&height=600&seq=renovation1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=kitchen%20renovation%20with%20white%20cabinets%2C%20marble%20countertops%2C%20modern%20appliances%2C%20clean%20design%2C%20bright%20lighting&width=800&height=600&seq=renovation2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=living%20room%20renovation%20with%20modern%20furniture%2C%20neutral%20colors%2C%20clean%20lines%2C%20bright%20natural%20lighting&width=800&height=600&seq=renovation3&orientation=landscape',
      'https://readdy.ai/api/search-image?query=bedroom%20renovation%20with%20minimalist%20design%2C%20white%20walls%2C%20modern%20furniture%2C%20clean%20aesthetic&width=800&height=600&seq=renovation4&orientation=landscape',
      'https://readdy.ai/api/search-image?query=home%20office%20renovation%20with%20modern%20desk%2C%20ergonomic%20chair%2C%20clean%20organization%2C%20bright%20lighting&width=800&height=600&seq=renovation5&orientation=landscape',
      'https://readdy.ai/api/search-image?query=hallway%20renovation%20with%20modern%20flooring%2C%20clean%20walls%2C%20contemporary%20lighting%20fixtures&width=800&height=600&seq=renovation6&orientation=landscape'
    ],
    'Hausmeisterservice': [
      'https://readdy.ai/api/search-image?query=Professional%20maintenance%20worker%20checking%20building%20systems%2C%20quality%20maintenance%20tools%20and%20equipment%2C%20skilled%20building%20maintenance%20work%20in%20residential%20property&width=800&height=600&seq=maintenance1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Building%20maintenance%20and%20repair%20work%2C%20professional%20handyman%20tools%2C%20quality%20maintenance%20services%20in%20apartment%20building%20or%20office%20complex&width=800&height=600&seq=maintenance2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Cleaning%20and%20maintenance%20of%20common%20areas%2C%20professional%20cleaning%20equipment%20and%20supplies%2C%20quality%20building%20maintenance%20services&width=800&height=600&seq=maintenance3&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Technical%20maintenance%20work%20on%20building%20systems%2C%20professional%20maintenance%20tools%20and%20equipment%2C%20skilled%20building%20maintenance%20in%20modern%20facility&width=800&height=600&seq=maintenance4&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Property%20maintenance%20and%20upkeep%20work%2C%20professional%20maintenance%20services%2C%20quality%20building%20care%20and%20maintenance%20in%20residential%20complex&width=800&height=600&seq=maintenance5&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Emergency%20maintenance%20and%20repair%20services%2C%20professional%20maintenance%20response%2C%20quality%20building%20maintenance%20work%20with%20modern%20tools&width=800&height=600&seq=maintenance6&orientation=landscape'
    ]
  };

  const dryWallImages = [
    'https://i.ibb.co/0Rht0yd5/2d4f8a5e-2a84-4159-b106-ed891eb747f7.jpg',
    'https://i.ibb.co/Hp97YcqV/4def328a-e716-46c8-933e-e165bbed3896.jpg',
    'https://i.ibb.co/nqpQWDS4/8e7c8ffa-e315-4437-98cc-85f062a88c14.jpg',
    'https://i.ibb.co/LD38HWCT/9a9bc5f2-0d21-42a4-87a5-a9427afdb904.jpg',
    'https://i.ibb.co/MDM8fBgk/031de91a-db3c-4d86-85c5-b26a4756daba.jpg',
    'https://i.ibb.co/39L3rQ0s/813c1976-d021-40e8-a34a-75d7db9cb5ed.jpg',
    'https://i.ibb.co/gqk1vf3/db0d4a66-a399-4d5d-8d9e-d1ce4566f427.jpg'
  ];

  const handleServiceClick = (index: number) => {
    setActiveService(activeService === index ? null : index);
  };

  return (
    <section id="services" className="py-20 bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-white mb-4">
            Unsere Leistungen
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Von kleinen Reparaturen bis zu großen Renovierungen - wir erledigen alle Arbeiten 
            rund um Ihr Zuhause mit höchster Qualität und Zuverlässigkeit.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="relative">
              <div 
                className={`bg-gray-800/50 border rounded-xl p-8 hover:shadow-xl transition-all duration-300 cursor-pointer group ${
                  activeService === index ? 'border-green-500 shadow-xl' : 'border-gray-700 hover:border-green-500'
                }`}
                onClick={() => handleServiceClick(index)}
              >
                <div className={`w-16 h-16 flex items-center justify-center rounded-full mb-6 transition-colors duration-300 ${
                  activeService === index ? 'bg-green-600' : 'bg-gray-700 group-hover:bg-green-600'
                }`}>
                  <i className={`${service.icon} text-3xl transition-colors duration-300 ${
                    activeService === index ? 'text-white' : 'text-green-400 group-hover:text-white'
                  }`}></i>
                </div>
                <h3 className="text-xl font-semibold text-white mb-4">
                  {service.title}
                </h3>
                <p className="text-gray-300 mb-6">
                  {service.description}
                </p>
                <ul className="space-y-2">
                  {service.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-center text-gray-400">
                      <i className="ri-check-line text-green-400 mr-2"></i>
                      {feature}
                    </li>
                  ))}
                </ul>
                <div className="mt-4 flex items-center justify-center">
                  <i className={`ri-arrow-${activeService === index ? 'up' : 'down'}-s-line text-green-400 text-xl transition-transform duration-300`}></i>
                </div>
              </div>

              {/* Ausfahrbares Galerie-Fenster */}
              <div className={`overflow-hidden transition-all duration-500 ease-in-out ${
                activeService === index ? 'max-h-96 opacity-100 mt-4' : 'max-h-0 opacity-0'
              }`}>
                <div className="bg-gray-800/70 border border-gray-600 rounded-xl p-6">
                  <h4 className="text-lg font-semibold text-white mb-4 text-center">
                    {service.title} - Unsere Arbeiten*
                  </h4>
                  <RollingGallery 
                    images={service.images}
                    autoplay={true}
                    pauseOnHover={true}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <button 
            onClick={() => {
              const element = document.querySelector('#contact');
              if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
              }
            }}
            className="whitespace-nowrap cursor-pointer bg-green-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-green-7 00 transition-colors duration-200 text-lg"
          >
            <i className="ri-phone-line mr-2"></i>
            Kostenvoranschlag anfragen
          </button>
        </div>

        {/* Hinweis für Beispielbilder */}
        <div className="mt-8 text-center">
          <p className="text-sm text-gray-500">
            *teilweise Beispielbilder
          </p>
        </div>
      </div>
    </section>
  );
}
